import { RouterView } from 'vue-router'

export const attendanceRoutes = [
  {
    path: 'reports',
    component: RouterView,
    children: [
      {
        path: 'performance',
        component: RouterView,
        children: [
          {
            name: 'attendance',
            path: 'attendance',
            component: () => import('@/modules/attendance/views/Attendance.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          }
        ]
      }
    ]
  }
]
